export default "__VITE_ASSET__BkQLP3Kl__"